<template>
<div class="chapter">
<div class="inner_page">
<p class="center" id="fm1"><a id="page_x"></a><a id="page_xi"></a><img alt="fm_map" src="image/fm_map.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780795344114_epub_fm1_r1.vue?247b463d